import { render, staticRenderFns } from "./accountcheck-summary.vue?vue&type=template&id=48714ead&scoped=true"
import script from "./accountcheck-summary.vue?vue&type=script&lang=js"
export * from "./accountcheck-summary.vue?vue&type=script&lang=js"
import style0 from "./accountcheck-summary.vue?vue&type=style&index=0&id=48714ead&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48714ead",
  null
  
)

export default component.exports